module.exports = __webpack_public_path__ + "img/IMG_20210710_200642 - SSRBon Jobi.7e09c825.png";